import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from './BuyButton';
import { trackAddToCart } from '../utils/metaPixel';
export function StickyBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-144" data-mp="jtprumnevuku">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-sand bg-cream/95 px-4 py-3 backdrop-blur" data-id="element-145" data-mp="evegg7hgxc0i">
          <div className="mx-auto flex max-w-4xl items-center justify-between gap-4" data-id="element-146" data-mp="24c5phblpvlc8">
            <p className="text-sm text-cocoa" data-id="element-147" data-mp="3idxlo8fkue7z">
              <span className="hidden sm:inline" data-id="element-148" data-mp="3ihd49l8gm5e5">Organiza Tu Vida en 7 Días · </span>
              <span className="mr-1.5 line-through opacity-60" data-id="element-149" data-mp="3mhwwqbi38kty">$19</span>
              <strong className="font-semibold text-terracotta" data-id="element-150" data-mp="38i4c8xx5n0uf">$9 USD</strong>
            </p>
            <a href={CHECKOUT_URL} onClick={() => trackAddToCart()} className="group inline-flex items-center gap-2 bg-terracotta px-5 py-3 text-xs font-semibold uppercase tracking-[0.12em] text-cream transition-colors hover:bg-cocoa focus:outline-none focus-visible:ring-2 focus-visible:ring-terracotta focus-visible:ring-offset-2" data-id="element-151" data-mp="3dgysbs3qmbau">
              Comprar ahora
              <ArrowRightIcon className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5" aria-hidden="true" data-id="element-152" data-mp="7t2099dyxl3" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}